import { isBalanceSufficient } from "./isBalanceSufficient";

type CanAddItemToCartParams = {
  cartTotalInCents: number;
  itemTotalInCents: number;
  period: string;
  periodLimit: number;
  spent: number;
  allowPurchaseWithNegativeBalance?: boolean;
};

export const canAddItemToCart = ({
  cartTotalInCents,
  itemTotalInCents,
  period,
  periodLimit,
  spent,
  allowPurchaseWithNegativeBalance,
}: CanAddItemToCartParams): boolean =>
  isBalanceSufficient({
    totalAmountInCents: cartTotalInCents + itemTotalInCents,
    period,
    periodLimit,
    spent,
    allowPurchaseWithNegativeBalance,
  });
